import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        backgroundColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        textAlign: 'center',
        fontStyle: 'bold',
    },
    shareholder: {
        width: '20%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    capital: {
        width: '20%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    common: {
        width: '30%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    pref: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    total: {
        width: '15%'
    }
  });

  const ShareTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.shareholder}>Name</Text>
        <Text style={styles.capital}># of Shares</Text>
        <Text style={styles.common}>Type</Text>
        <Text style={styles.pref}>Purchase Date</Text>
        <Text style={styles.total}>Revoked Date</Text>
    </View>
  );
  
  export default ShareTableHeader